module.exports = __webpack_public_path__ + "img/logo.64fd2938.svg";